import { ModuleData, RoleData, RoleModuleData } from "types/models/roleMaster/RoleMasterApp";

export const GET_ROLE = "GET_ROLE";
export const SET_ROLE = "SET_ROLE";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";

export const GET_MODULES = "GET_MODULES";
export const SET_MODULES = "SET_MODULES";

export const CREATE_ROLE_MODULE = "CREATE_ROLE_MODULE";
export const GET_ROLE_MODULES = "GET_ROLE_MODULES";



export interface GetRoleAction {
  type: typeof GET_ROLE;
  payload: { data: RoleData[]; total: number};
}
export interface SetRoleAction {
  type: typeof SET_ROLE;
  payload: RoleData;
}
export interface CreateRole{
  type: typeof CREATE_ROLE;
    payload: any; 
}
export interface UpdateRole{
  type: typeof UPDATE_ROLE;
  payload:any;
}

export interface DeleteRole{
  type: typeof DELETE_ROLE;
  payload: any;
}

export interface GetModuleAction {
  type: typeof GET_MODULES;
  payload: { data: ModuleData[]; total: number};
}
export interface SetModuleAction {
  type: typeof SET_MODULES;
  payload: ModuleData;
}

export interface GetRoleModuleAction {
  type: typeof GET_ROLE_MODULES;
  payload: { data: RoleModuleData[]; total: number};
}

export type RoleMasterActionTypes =
  | GetRoleAction
  | SetRoleAction
  | CreateRole
  | UpdateRole
  | DeleteRole
  | GetModuleAction
  | SetModuleAction
  | GetRoleModuleAction